import { render } from "./DonutWithPattern.vue?vue&type=template&id=77b85c40"
import script from "./DonutWithPattern.vue?vue&type=script&lang=js"
export * from "./DonutWithPattern.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__